module.exports = __webpack_public_path__ + "static/img/2.09f2812.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/sp/2.png
// module id = rxfK
// module chunks = 0